import { FC } from 'react'
import Slider from '../../../common/components/Slider'
import { OnResponseSubmit, Option, StepResponse } from '../../../types/Exercise'
import styles from './ScaleExercise.module.css'

interface ScaleExerciseProps {
  id: number
  data: {
    options: Option[]
  }
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const ScaleExercise: FC<ScaleExerciseProps> = ({
  id,
  data,
  onResponseSubmit,
  stepResponse,
}) => {
  const options = data.options.map(({ option }) => option)

  const onValueChange = (newValue: number) => {
    onResponseSubmit(id, newValue)
  }

  return (
    <div className={styles.scaleContainer}>
      <Slider
        labels={options}
        onChange={onValueChange}
        sliderValue={stepResponse?.response}
      />
    </div>
  )
}

export default ScaleExercise
